import apiClient from "./apiService";
import { Student, StudentQueryParams } from "@/interfaces/Student";

export default {
  async getStudentProfile(userId: number): Promise<ApiResponse<Student>> {
    const response = await apiClient.get<ApiResponse<Student>>(
      `/students/${userId}/profile`
    );
    return response.data;
  },
  async getStudents(url: string, params?: StudentQueryParams) {
    try {
      const response = await apiClient.get(url, { params });
      return response.data;
    } catch (error) {
      console.error("Error fetching students:", error);
      throw error;
    }
  },
};
